import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { openCurrentYear } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';
import { showErrorSnackbar } from 'components/shared/Snackbar';

/**
 * The 409 the backend answers when the BPM relevance cleanup has already permanently purged the
 * workflow history of the year being reopened.
 *
 * Only this key crosses the event bus: the per-rule summary the service builds (which rule, in
 * which mode, how many instances, when) is logged server-side and is not part of the response, so
 * the year shown here comes from the row that was clicked.
 */
const PURGED_HISTORY_NOT_ACKNOWLEDGED =
  'year-closure.error.purged-history-not-acknowledged';

export const useOpenYear = () => {
  const { t } = useTranslation('common');
  const queryClient = useQueryClient();
  return useMutation((_year?: number) => openCurrentYear(), {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['yearClosure', 'list']
      });
      showSnackbar({
        severity: 'success',
        message: t('yearClosure.year_open_success')
      });
    },
    onError: (error: any, year) => {
      if (
        error?.response?.data?.error?.message ===
        PURGED_HISTORY_NOT_ACKNOWLEDGED
      ) {
        showErrorSnackbar(
          t(PURGED_HISTORY_NOT_ACKNOWLEDGED, { year: year ?? '' })
        );
        return;
      }
      showErrorSnackbar();
    }
  });
};
